<vt-styled-authorization-page [content]="passwordForm"></vt-styled-authorization-page>    

<ng-template  #passwordForm>
  <vt-forgot-password-request-form
    (submitted)="onSubmit($event)">
  </vt-forgot-password-request-form>
</ng-template>